module.exports = __webpack_public_path__ + "img/small-abstract-1.fe97066.svg";